import dayjs from 'dayjs';

export const getISODate = (date: string, timeZone: string, startDate = true): string => {
  const localizedDate = dayjs.tz(date, timeZone);

  const dateStartOrEnd = startDate ? localizedDate.startOf('day') : localizedDate.endOf('day');

  return dateStartOrEnd.utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
};
